// Push Nav
// https://github.com/gdsmith/jquery.easing/blob/master/jquery.easing.js - easeInQuint
import $ from 'jquery';
import _ from 'underscore';
import AnimationFrame from './new/Animation';

class Navigation {

  constructor( stickyNavigation ) {

    let anim = new AnimationFrame;

    this.sticky = stickyNavigation;

    // this.$body = $('body');
    // this.$wrapper = $('div.wrapper.push');
    // this.$toggle = $('.mobile-toggle');

    // this.$wrapper.append('<div class="cover"></div>').click(event => {
    //   this.$body.removeClass('open');
    //   this.fixFixed();
    // });

    // this.$toggle.click(event => {
    //   event.preventDefault();
    //   this.$body.toggleClass('open');
    //   this.fixFixed(); // because we're using translates to open mobile view., fixed elements disappear.
    // });

    $('.js-anchor-menu').find('a').click(event => {
      $('.js-anchor-menu > li').removeClass('active');
      $(event.currentTarget).parent().addClass('active');
    });

    this.bind();

    // With the following URL "/developments/view/karaka" scroll to element with this selector [data-uri="karaka"]
    let segments = window.location.pathname.toString().split( '/' );
    let target = _.indexOf(segments, 'view') + 1;
    let targetByName = segments[target];
    this.scrollTo('div[data-uri="' + targetByName + '"]');
  }

  get state() {
    return (this.$body.hasClass('open') == true) ? 'open' : 'closed' ;
  }

  fixFixed() {
    //fix from top
    if (this.state == 'open') {
      _.each(this.sticky.$targets, target => {
        $(target).css('top', window.pageYOffset);
      });
      return;
    }
    //remove fix from top
    if (this.state == 'closed') {
      _.each(this.sticky.$targets, target => {
        $(target).css('top', $(target).data('offset') + $('div.navbar').outerHeight());
      });
    }
  }

  easing(x, t, b, c, d) {
    return c * (t /= d) * t * t * t * t + b;
  }

  scrollTop() {
    $('[data-scroll-top]').click(event => {
      event.preventDefault();
      $('html, body').animate({
        scrollTop: 0
      },
      200,
      this.easing
      );
    });
  }

  scrollTo(selector, offset = 140) {
    let $target = $(selector);
    if ($target.length) {
      setTimeout(function () {
        $('html, body').animate({
            scrollTop: $target.offset().top - offset
          },
          200,
          this.easing
        );
      }, 1);
      $(document).unbind("scroll");
    }
  }

  bind() {
    $("[data-scroll-to]").click(e => {
      e.preventDefault();

      /**
       * Supports the following selectors:
       *
       * 1. '[name="selector"]'
       * 2. '#selector'
       * 3. '[data-uri="selector"]'
       */

      var $curTarg = $(e.currentTarget),
        offset = $curTarg.data('offset'),
        target = $curTarg.data('target') || $curTarg.prop('hash').substring(1),
        targetSelector = '[name="' + target + '"]';

      if ($curTarg.data('target-type') === 'id') {
        targetSelector = '#' + target;
      } else if($curTarg.data('target-type') === 'uri') {
        targetSelector = '[data-uri="' + target + '"]';
      }

      this.scrollTo(targetSelector, offset);
    });
  }
}


class StickyNavigation {

  constructor() {
    let anim = new AnimationFrame;

    this.ticking = false;
    this.bind();
  }

  requestTick() {
    if(!this.ticking) {
      requestAnimationFrame( () => this.update() );
      this.ticking = true;
    }
  }

  bind() {
    this.$targets = $('[data-sticky]');
    _.each(this.$targets, target => {
      target.wrapper = $(target).wrap('<div class="sticky-wrapper"></div>');
    });
    window.addEventListener('scroll', () => this.requestTick(), true);

    this.update(); // check on first run.
  }

  update() {
    this.ticking = false;
    let scrolly = window.pageYOffset;

    _.each(this.$targets, target => {

      let breakpoint;
      let navbarHeight = $('div.navbar').outerHeight() > 30 ? $('div.navbar').outerHeight() : 76;

      if($('.site-header .navbar').hasClass('hide-navbar')){
        navbarHeight = 0;
      }

    $(target).parent().css('height', $(target).outerHeight());
      if (!$(target).hasClass('stuck')) {
        breakpoint = $(target).offset().top - $(target).data('offset'); // Isn't pinned
        //breakpoint = $(target).offset().top - $(target).data('offset') - navbar; // Isn't pinned
      } else {
        breakpoint = $(target).parent().offset().top - $(target).data('offset') - navbarHeight; // Is already pinned
      }

      // Should be stuck
      if (scrolly > breakpoint &! $(target).hasClass('stuck')) {
        // $(target).addClass('hide-navbar');
        $(target).addClass('stuck');
        if (!$(target).hasClass('dev-superlot')) {
          $(target).css('top', $(target).data('offset') + navbarHeight); // With header navigation
        //   $(target).parent().css('height', $(target).outerHeight()); // removed due to issues with extra space when scrolling back to top
        }
        return;
      }

      // Should not be stuck
      if (scrolly < breakpoint) {
        // $(target).removeClass('hide-navbar');
        $(target).removeClass('stuck');
        $(target).css('top', '');
        // $(target).parent().css('height', 0);

        return;
      }
    });
  };
}

export { Navigation, StickyNavigation };
